export default [
  {
    path: '/holidays',
    name: 'holiday',
    meta: { requiresAuth: true },
    component: () => import('@/pages/holiday/index.vue')
  }
]
